import type { PopoverContentProps } from '@radix-ui/react-popover'
import { Popover } from 'radix-ui'
import { useState, type PropsWithChildren } from 'react'
import { IconButton } from '~/shared/ui/icon-button'
import { LocalIcon } from '~/shared/ui/local-icon'

export function InfoTip({
  children,
  iconSize = '18',
  align = 'start',
  defaultOpen = false,
}: PropsWithChildren & {
  iconSize?: '16' | '18' | '24'
  align?: PopoverContentProps['align']
  defaultOpen?: boolean
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Popover.Trigger
        className="cursor-pointer border-none bg-transparent p-0"
        onClick={() => setIsOpen(true)}
      >
        <LocalIcon
          className="text-content-high-emphasis block"
          name="infoOutlined"
          size={iconSize}
        />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="bg-surface-lowest relative z-9999 rounded-sm px-4 py-4 whitespace-normal shadow-[0_0.5px_1.75px_0_rgba(0,0,0,0.04),0_1.85px_6.25px_0_rgba(0,0,0,0.19)]"
          sideOffset={8}
          onOpenAutoFocus={(e) => e.preventDefault()}
          align={align}
          collisionPadding={8}
        >
          <IconButton
            className="absolute top-2 right-2"
            onClick={() => setIsOpen(false)}
            size="medium"
            container="small"
            materialIcon="close"
          />
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
